// Garden Gnome Software - Skin
// Pano2VR 3.1.4/1954
// Filename: LutkovnoGledalisce_MOBILNO.ggsk
// Generated čet 19. apr 17:00:32 2012

function pano2vrSkin(player,base) {
	var me=this;
	var flag=false;
	this.player=player;
	this.player.skinObj=this;
	this.divSkin=player.divSkin;
	var basePath="";
	// auto detect base path
	if (base=='?') {
		var scripts = document.getElementsByTagName('script');
		for(var i=0;i<scripts.length;i++) {
			var src=scripts[i].src;
			if (src.indexOf('skin.js')>=0) {
				var p=src.lastIndexOf('/');
				if (p>=0) {
					basePath=src.substr(0,p+1);
				}
			}
		}
	} else
	if (base) {
		basePath=base;
	}
	this.elementMouseDown=new Array();
	this.elementMouseOver=new Array();
	var cssPrefix='';
	var domTransition='transition';
	var domTransform='transform';
	var prefixes='Webkit,Moz,O,ms,Ms'.split(',');
	var i;
	for(i=0;i<prefixes.length;i++) {
		if (typeof document.body.style[prefixes[i] + 'Transform'] !== 'undefined') {
			cssPrefix='-' + prefixes[i].toLowerCase() + '-';
			domTransition=prefixes[i] + 'Transition';
			domTransform=prefixes[i] + 'Transform';
		}
	}
	
	this.player.setMargins(0,0,0,0);
	
	this.updateSize=function(startElement) {
		var stack=new Array();
		stack.push(startElement);
		while(stack.length>0) {
			e=stack.pop();
			if (e.ggUpdatePosition) {
				e.ggUpdatePosition();
			}
			if (e.hasChildNodes()) {
				for(i=0;i<e.childNodes.length;i++) {
					stack.push(e.childNodes[i]);
				}
			}
		}
	}
	
	parameterToTransform=function(p) {
		return 'translate(' + p.rx + 'px,' + p.ry + 'px) rotate(' + p.a + 'deg) scale(' + p.sx + ',' + p.sy + ')';
	}
	
	this.findElements=function(id,regex) {
		var r=new Array();
		var stack=new Array();
		var pat=new RegExp(id,'');
		stack.push(me.divSkin);
		while(stack.length>0) {
			e=stack.pop();
			if (regex) {
				if (pat.test(e.ggId)) r.push(e);
			} else {
				if (e.ggId==id) r.push(e);
			}
			if (e.hasChildNodes()) {
				for(i=0;i<e.childNodes.length;i++) {
					stack.push(e.childNodes[i]);
				}
			}
		}
		return r;
	}
	
	this.preloadImages=function() {
		var preLoadImg=new Image();
		preLoadImg.src=basePath + 'images/right__o.png';
		preLoadImg.src=basePath + 'images/left__o.png';
		preLoadImg.src=basePath + 'images/down__o.png';
		preLoadImg.src=basePath + 'images/up__o.png';
		preLoadImg.src=basePath + 'images/info__o.png';
		preLoadImg.src=basePath + 'images/prehodi__o.png';
		preLoadImg.src=basePath + 'images/prehodi__a.png';
		preLoadImg.src=basePath + 'images/odpriprehodi__o.png';
		preLoadImg.src=basePath + 'images/odpriprehodi__a.png';
	}
	
	this.addSkin=function() {
		this._userdata=document.createElement('div');
		this._userdata.ggId='Userdata'
		this._userdata.ggParameter={ rx:0,ry:0,a:0,sx:1,sy:1 };
		this._userdata.ggVisible=true;
		this._userdata.ggUpdatePosition=function() {
			this.style[domTransition]='none';
			if (this.parentNode) {
				w=this.parentNode.offsetWidth;
				this.style.left=(-191 + w/2) + 'px';
				h=this.parentNode.offsetHeight;
				this.style.top=(-119 + h/2) + 'px';
			}
		}
		hs ='position:absolute;';
		hs+='left: -191px;';
		hs+='top:  -119px;';
		hs+='width: 273px;';
		hs+='height: 211px;';
		hs+=cssPrefix + 'transform-origin: 50% 50%;';
		hs+='visibility: inherit;';
		hs+='border: 2px solid #aa0000;';
		hs+='background-image:url(' + basePath + 'images/alpha_background_000000_128.png);';
		this._userdata.setAttribute('style',hs);
		this._userdata.onclick=function () {
			me._userdata.style[domTransition]='none';
			me._userdata.style.visibility='hidden';
			me._userdata.ggVisible=false;
		}
		this._image_39=document.createElement('div');
		this._image_39.ggId='Image 39'
		this._image_39.ggParameter={ rx:0,ry:0,a:0,sx:1,sy:1 };
		this._image_39.ggVisible=true;
		hs ='position:absolute;';
		hs+='left: 269px;';
		hs+='top:  24px;';
		hs+='width: 119px;';
		hs+='height: 198px;';
		hs+=cssPrefix + 'transform-origin: 50% 50%;';
		hs+='visibility: inherit;';
		this._image_39.setAttribute('style',hs);
		this._image_39__img=document.createElement('img');
		this._image_39__img.setAttribute('src',basePath + 'images/image_39.png');
		this._image_39__img.setAttribute('style','position: absolute;top: 0px;left: 0px;');
		me.player.checkLoaded.push(this._image_39__img);
		this._image_39.appendChild(this._image_39__img);
		this._image_39.onmouseover=function () {
			me._full_screen.innerHTML="uporabi prst :: navigate with your finger";
			if (me._full_screen.ggUpdateText) {
				me._full_screen.ggUpdateText=function() {
					me._full_screen.innerHTML="uporabi prst :: navigate with your finger";
				}
			}
			me._full_screen.style[domTransition]='none';
			me._full_screen.style.visibility='inherit';
			me._full_screen.ggVisible=true;
		}
		this._image_39.onmouseout=function () {
			me._full_screen.style[domTransition]='none';
			me._full_screen.style.visibility='hidden';
			me._full_screen.ggVisible=false;
		}
		this._userdata.appendChild(this._image_39);
		this._loading_close=document.createElement('div');
		this._loading_close.ggId='loading close'
		this._loading_close.ggParameter={ rx:0,ry:0,a:0,sx:1,sy:1 };
		this._loading_close.ggVisible=true;
		hs ='position:absolute;';
		hs+='left: 274px;';
		hs+='top:  -6px;';
		hs+='width: 24px;';
		hs+='height: 24px;';
		hs+=cssPrefix + 'transform-origin: 50% 50%;';
		hs+='visibility: inherit;';
		this._loading_close.setAttribute('style',hs);
		this._loading_close__img=document.createElement('img');
		this._loading_close__img.setAttribute('src',basePath + 'images/loading_close.png');
		this._loading_close__img.setAttribute('style','position: absolute;top: 0px;left: 0px;');
		me.player.checkLoaded.push(this._loading_close__img);
		this._loading_close.appendChild(this._loading_close__img);
		this._loading_close.onclick=function () {
			me._userdata.style[domTransition]='none';
			me._userdata.style.visibility='hidden';
			me._userdata.ggVisible=false;
		}
		this._userdata.appendChild(this._loading_close);
		this._title=document.createElement('div');
		this._title.ggId='title'
		this._title.ggParameter={ rx:0,ry:0,a:0,sx:1,sy:1 };
		this._title.ggVisible=true;
		hs ='position:absolute;';
		hs+='left: -1px;';
		hs+='top:  4px;';
		hs+='width: 270px;';
		hs+='height: auto;';
		hs+=cssPrefix + 'transform-origin: 50% 50%;';
		hs+='visibility: inherit;';
		hs+='border: 0px solid #000000;';
		hs+='color: #ffffff;';
		hs+='text-align: left;';
		hs+='white-space: pre-wrap;';
		hs+='padding: 0px 1px 0px 1px;'
		hs+='overflow: hidden;';
		this._title.setAttribute('style',hs);
		this._title.ggUpdateText=function() {
			this.innerHTML="<b>"+me.player.userdata.title+"<\/b>";
		}
		this._title.ggUpdateText();
		this._userdata.appendChild(this._title);
		this._author=document.createElement('div');
		this._author.ggId='author'
		this._author.ggParameter={ rx:0,ry:0,a:0,sx:1,sy:1 };
		this._author.ggVisible=true;
		hs ='position:absolute;';
		hs+='left: -1px;';
		hs+='top:  134px;';
		hs+='width: 268px;';
		hs+='height: auto;';
		hs+=cssPrefix + 'transform-origin: 50% 50%;';
		hs+='visibility: inherit;';
		hs+='border: 0px solid #000000;';
		hs+='color: #ffffff;';
		hs+='text-align: left;';
		hs+='white-space: pre-wrap;';
		hs+='padding: 0px 1px 0px 1px;'
		hs+='overflow: hidden;';
		this._author.setAttribute('style',hs);
		this._author.ggUpdateText=function() {
			this.innerHTML=me.player.userdata.author;
		}
		this._author.ggUpdateText();
		this._userdata.appendChild(this._author);
		this._datetime=document.createElement('div');
		this._datetime.ggId='datetime'
		this._datetime.ggParameter={ rx:0,ry:0,a:0,sx:1,sy:1 };
		this._datetime.ggVisible=true;
		hs ='position:absolute;';
		hs+='left: -1px;';
		hs+='top:  189px;';
		hs+='width: 257px;';
		hs+='height: auto;';
		hs+=cssPrefix + 'transform-origin: 50% 50%;';
		hs+='visibility: inherit;';
		hs+='border: 0px solid #000000;';
		hs+='color: #ffffff;';
		hs+='text-align: left;';
		hs+='white-space: pre-wrap;';
		hs+='padding: 0px 1px 0px 1px;'
		hs+='overflow: hidden;';
		this._datetime.setAttribute('style',hs);
		this._datetime.ggUpdateText=function() {
			this.innerHTML=me.player.userdata.datetime;
		}
		this._datetime.ggUpdateText();
		this._userdata.appendChild(this._datetime);
		this._description=document.createElement('div');
		this._description.ggId='description'
		this._description.ggParameter={ rx:0,ry:0,a:0,sx:1,sy:1 };
		this._description.ggVisible=true;
		hs ='position:absolute;';
		hs+='left: -1px;';
		hs+='top:  49px;';
		hs+='width: 265px;';
		hs+='height: auto;';
		hs+=cssPrefix + 'transform-origin: 50% 50%;';
		hs+='visibility: inherit;';
		hs+='border: 0px solid #000000;';
		hs+='color: #ffffff;';
		hs+='text-align: left;';
		hs+='white-space: pre-wrap;';
		hs+='padding: 0px 1px 0px 1px;'
		hs+='overflow: hidden;';
		this._description.setAttribute('style',hs);
		this._description.ggUpdateText=function() {
			this.innerHTML=me.player.userdata.description;
		}
		this._description.ggUpdateText();
		this._userdata.appendChild(this._description);
		this._copyright=document.createElement('div');
		this._copyright.ggId='copyright'
		this._copyright.ggParameter={ rx:0,ry:0,a:0,sx:1,sy:1 };
		this._copyright.ggVisible=true;
		hs ='position:absolute;';
		hs+='left: -1px;';
		hs+='top:  169px;';
		hs+='width: auto;';
		hs+='height: auto;';
		hs+=cssPrefix + 'transform-origin: 50% 50%;';
		hs+='visibility: inherit;';
		hs+='border: 0px solid #000000;';
		hs+='color: #ffffff;';
		hs+='text-align: left;';
		hs+='white-space: nowrap;';
		hs+='padding: 0px 1px 0px 1px;'
		hs+='overflow: hidden;';
		this._copyright.setAttribute('style',hs);
		this._copyright.ggUpdateText=function() {
			this.innerHTML="&#169; "+me.player.userdata.copyright;
		}
		this._copyright.ggUpdateText();
		this._userdata.appendChild(this._copyright);
		this.divSkin.appendChild(this._userdata);
		this._loading_image=document.createElement('div');
		this._loading_image.ggId='loading image'
		this._loading_image.ggParameter={ rx:0,ry:0,a:0,sx:1,sy:1 };
		this._loading_image.ggVisible=true;
		this._loading_image.ggUpdatePosition=function() {
			this.style[domTransition]='none';
			if (this.parentNode) {
				w=this.parentNode.offsetWidth;
				this.style.left=(-215 + w/2) + 'px';
				h=this.parentNode.offsetHeight;
				this.style.top=(-118 + h/2) + 'px';
			}
		}
		hs ='position:absolute;';
		hs+='left: -215px;';
		hs+='top:  -118px;';
		hs+='width: 300px;';
		hs+='height: 150px;';
		hs+=cssPrefix + 'transform-origin: 50% 50%;';
		hs+='visibility: inherit;';
		this._loading_image.setAttribute('style',hs);
		this._loading_image__img=document.createElement('img');
		this._loading_image__img.setAttribute('src',basePath + 'images/loading_image.png');
		this._loading_image__img.setAttribute('style','position: absolute;top: 0px;left: 0px;');
		me.player.checkLoaded.push(this._loading_image__img);
		this._loading_image.appendChild(this._loading_image__img);
		this._loading_bar=document.createElement('div');
		this._loading_bar.ggId='loading bar'
		this._loading_bar.ggParameter={ rx:0,ry:0,a:0,sx:1,sy:1 };
		this._loading_bar.ggVisible=true;
		hs ='position:absolute;';
		hs+='left: 5px;';
		hs+='top:  130px;';
		hs+='width: 290px;';
		hs+='height: 19px;';
		hs+=cssPrefix + 'transform-origin: 0% 50%;';
		hs+='visibility: inherit;';
		hs+='border: 1px solid #ff0000;';
		hs+='background-color: #55aaff;';
		this._loading_bar.setAttribute('style',hs);
		this._loading_image.appendChild(this._loading_bar);
		this._loading_text=document.createElement('div');
		this._loading_text.ggId='loading text'
		this._loading_text.ggParameter={ rx:0,ry:0,a:0,sx:1,sy:1 };
		this._loading_text.ggVisible=true;
		hs ='position:absolute;';
		hs+='left: -290px;';
		hs+='top:  525px;';
		hs+='width: 270px;';
		hs+='height: 20px;';
		hs+=cssPrefix + 'transform-origin: 50% 50%;';
		hs+='visibility: inherit;';
		hs+='border: 0px solid #000000;';
		hs+='color: #000000;';
		hs+='text-align: left;';
		hs+='white-space: nowrap;';
		hs+='padding: 0px 1px 0px 1px;'
		hs+='overflow: hidden;';
		this._loading_text.setAttribute('style',hs);
		this._loading_text.ggUpdateText=function() {
			this.innerHTML="<b>Priprava :: Loading... "+(me.player.getPercentLoaded()*100.0).toFixed(0)+"%<\/b>";
		}
		this._loading_text.ggUpdateText();
		this._loading_image.appendChild(this._loading_text);
		this.divSkin.appendChild(this._loading_image);
		this._desno=document.createElement('div');
		this._desno.ggId='DESNO'
		this._desno.ggParameter={ rx:0,ry:0,a:0,sx:1,sy:1 };
		this._desno.ggVisible=false;
		this._desno.ggUpdatePosition=function() {
			this.style[domTransition]='none';
			if (this.parentNode) {
				w=this.parentNode.offsetWidth;
				this.style.left=(-50 + w) + 'px';
				h=this.parentNode.offsetHeight;
				this.style.top=(-68 + h/2) + 'px';
			}
		}
		hs ='position:absolute;';
		hs+='left: -50px;';
		hs+='top:  -68px;';
		hs+='width: 47px;';
		hs+='height: 110px;';
		hs+=cssPrefix + 'transform-origin: 0% 50%;';
		hs+='visibility: hidden;';
		hs+='cursor: pointer;';
		hs+='border: 0px solid #000000;';
		this._desno.setAttribute('style',hs);
		this._right=document.createElement('div');
		this._right.ggId='right'
		this._right.ggParameter={ rx:0,ry:0,a:0,sx:1,sy:1 };
		this._right.ggVisible=true;
		this._right.ggUpdatePosition=function() {
			this.style[domTransition]='none';
			if (this.parentNode) {
				w=this.parentNode.offsetWidth;
				this.style.left=(-47 + w) + 'px';
				h=this.parentNode.offsetHeight;
				this.style.top=(-55 + h/2) + 'px';
			}
		}
		hs ='position:absolute;';
		hs+='left: -47px;';
		hs+='top:  -55px;';
		hs+='width: 50px;';
		hs+='height: 100px;';
		hs+=cssPrefix + 'transform-origin: 0% 50%;';
		hs+='opacity: 0.2;';
		hs+='visibility: inherit;';
		hs+='cursor: pointer;';
		this._right.setAttribute('style',hs);
		this._right__img=document.createElement('img');
		this._right__img.setAttribute('src',basePath + 'images/right.png');
		this._right__img.setAttribute('style','position: absolute;top: 0px;left: 0px;');
		me.player.checkLoaded.push(this._right__img);
		this._right.appendChild(this._right__img);
		this._right.onmouseover=function () {
			me.player.changePan(-1,true);
			me._right.style[domTransition]='none';
			me._right.style.opacity='1';
			me._right.style.visibility=me._right.ggVisible?'inherit':'hidden';
			me._right__img.src=basePath + 'images/right__o.png';
		}
		this._right.onmouseout=function () {
			me._right.style[domTransition]='none';
			me._right.style.opacity='0.3';
			me._right.style.visibility=me._right.ggVisible?'inherit':'hidden';
			me._right__img.src=basePath + 'images/right.png';
			me.elementMouseDown['right']=false;
		}
		this._right.onmousedown=function () {
			me.elementMouseDown['right']=true;
		}
		this._right.onmouseup=function () {
			me.elementMouseDown['right']=false;
		}
		this._right.ontouchend=function () {
			me.elementMouseDown['right']=false;
		}
		this._desno.appendChild(this._right);
		this.divSkin.appendChild(this._desno);
		this._levo=document.createElement('div');
		this._levo.ggId='LEVO'
		this._levo.ggParameter={ rx:0,ry:0,a:0,sx:1,sy:1 };
		this._levo.ggVisible=false;
		this._levo.ggUpdatePosition=function() {
			this.style[domTransition]='none';
			if (this.parentNode) {
				h=this.parentNode.offsetHeight;
				this.style.top=(-68 + h/2) + 'px';
			}
		}
		hs ='position:absolute;';
		hs+='left: 0px;';
		hs+='top:  -68px;';
		hs+='width: 27px;';
		hs+='height: 118px;';
		hs+=cssPrefix + 'transform-origin: 50% 50%;';
		hs+='visibility: hidden;';
		hs+='cursor: pointer;';
		hs+='border: 0px solid #000000;';
		this._levo.setAttribute('style',hs);
		this._left=document.createElement('div');
		this._left.ggId='left'
		this._left.ggParameter={ rx:0,ry:0,a:0,sx:1,sy:1 };
		this._left.ggVisible=true;
		this._left.ggUpdatePosition=function() {
			this.style[domTransition]='none';
			if (this.parentNode) {
				h=this.parentNode.offsetHeight;
				this.style.top=(-54 + h/2) + 'px';
			}
		}
		hs ='position:absolute;';
		hs+='left: 0px;';
		hs+='top:  -54px;';
		hs+='width: 50px;';
		hs+='height: 100px;';
		hs+=cssPrefix + 'transform-origin: 50% 50%;';
		hs+='opacity: 0.2;';
		hs+='visibility: inherit;';
		hs+='cursor: pointer;';
		this._left.setAttribute('style',hs);
		this._left__img=document.createElement('img');
		this._left__img.setAttribute('src',basePath + 'images/left.png');
		this._left__img.setAttribute('style','position: absolute;top: 0px;left: 0px;');
		me.player.checkLoaded.push(this._left__img);
		this._left.appendChild(this._left__img);
		this._left.onmouseover=function () {
			me.player.changePan(1,true);
			me._left.style[domTransition]='none';
			me._left.style.opacity='1';
			me._left.style.visibility=me._left.ggVisible?'inherit':'hidden';
			me._left__img.src=basePath + 'images/left__o.png';
		}
		this._left.onmouseout=function () {
			me._left.style[domTransition]='none';
			me._left.style.opacity='0.3';
			me._left.style.visibility=me._left.ggVisible?'inherit':'hidden';
			me._left__img.src=basePath + 'images/left.png';
			me.elementMouseDown['left']=false;
		}
		this._left.onmousedown=function () {
			me.elementMouseDown['left']=true;
		}
		this._left.onmouseup=function () {
			me.elementMouseDown['left']=false;
		}
		this._left.ontouchend=function () {
			me.elementMouseDown['left']=false;
		}
		this._levo.appendChild(this._left);
		this.divSkin.appendChild(this._levo);
		this._dol=document.createElement('div');
		this._dol.ggId='DOL'
		this._dol.ggParameter={ rx:0,ry:0,a:0,sx:1,sy:1 };
		this._dol.ggVisible=false;
		this._dol.ggUpdatePosition=function() {
			this.style[domTransition]='none';
			if (this.parentNode) {
				w=this.parentNode.offsetWidth;
				this.style.left=(-60 + w/2) + 'px';
				h=this.parentNode.offsetHeight;
				this.style.top=(-36 + h) + 'px';
			}
		}
		hs ='position:absolute;';
		hs+='left: -60px;';
		hs+='top:  -36px;';
		hs+='width: 100px;';
		hs+='height: 24px;';
		hs+=cssPrefix + 'transform-origin: 50% 50%;';
		hs+='visibility: hidden;';
		hs+='cursor: pointer;';
		hs+='border: 0px solid #000000;';
		this._dol.setAttribute('style',hs);
		this._down=document.createElement('div');
		this._down.ggId='down'
		this._down.ggParameter={ rx:0,ry:0,a:0,sx:1,sy:1 };
		this._down.ggVisible=true;
		this._down.ggUpdatePosition=function() {
			this.style[domTransition]='none';
			if (this.parentNode) {
				w=this.parentNode.offsetWidth;
				this.style.left=(-50 + w/2) + 'px';
			}
		}
		hs ='position:absolute;';
		hs+='left: -50px;';
		hs+='top:  -25px;';
		hs+='width: 100px;';
		hs+='height: 50px;';
		hs+=cssPrefix + 'transform-origin: 50% 50%;';
		hs+='opacity: 0.2;';
		hs+='visibility: inherit;';
		hs+='cursor: pointer;';
		this._down.setAttribute('style',hs);
		this._down__img=document.createElement('img');
		this._down__img.setAttribute('src',basePath + 'images/down.png');
		this._down__img.setAttribute('style','position: absolute;top: 0px;left: 0px;');
		me.player.checkLoaded.push(this._down__img);
		this._down.appendChild(this._down__img);
		this._down.onmouseover=function () {
			me.player.changeTilt(-1,true);
			me._down.style[domTransition]='none';
			me._down.style.opacity='1';
			me._down.style.visibility=me._down.ggVisible?'inherit':'hidden';
			me._down__img.src=basePath + 'images/down__o.png';
		}
		this._down.onmouseout=function () {
			me._down.style[domTransition]='none';
			me._down.style.opacity='0.3';
			me._down.style.visibility=me._down.ggVisible?'inherit':'hidden';
			me._down__img.src=basePath + 'images/down.png';
			me.elementMouseDown['down']=false;
		}
		this._down.onmousedown=function () {
			me.elementMouseDown['down']=true;
		}
		this._down.onmouseup=function () {
			me.elementMouseDown['down']=false;
		}
		this._down.ontouchend=function () {
			me.elementMouseDown['down']=false;
		}
		this._dol.appendChild(this._down);
		this.divSkin.appendChild(this._dol);
		this._gor=document.createElement('div');
		this._gor.ggId='GOR'
		this._gor.ggParameter={ rx:0,ry:0,a:0,sx:1,sy:1 };
		this._gor.ggVisible=false;
		this._gor.ggUpdatePosition=function() {
			this.style[domTransition]='none';
			if (this.parentNode) {
				w=this.parentNode.offsetWidth;
				this.style.left=(-60 + w/2) + 'px';
			}
		}
		hs ='position:absolute;';
		hs+='left: -60px;';
		hs+='top:  10px;';
		hs+='width: 100px;';
		hs+='height: 27px;';
		hs+=cssPrefix + 'transform-origin: 50% 50%;';
		hs+='visibility: hidden;';
		hs+='cursor: pointer;';
		hs+='border: 0px solid #000000;';
		this._gor.setAttribute('style',hs);
		this._up=document.createElement('div');
		this._up.ggId='up'
		this._up.ggParameter={ rx:0,ry:0,a:0,sx:1,sy:1 };
		this._up.ggVisible=true;
		this._up.ggUpdatePosition=function() {
			this.style[domTransition]='none';
			if (this.parentNode) {
				w=this.parentNode.offsetWidth;
				this.style.left=(-50 + w/2) + 'px';
			}
		}
		hs ='position:absolute;';
		hs+='left: -50px;';
		hs+='top:  -5px;';
		hs+='width: 100px;';
		hs+='height: 50px;';
		hs+=cssPrefix + 'transform-origin: 50% 50%;';
		hs+='opacity: 0.2;';
		hs+='visibility: inherit;';
		hs+='cursor: pointer;';
		this._up.setAttribute('style',hs);
		this._up__img=document.createElement('img');
		this._up__img.setAttribute('src',basePath + 'images/up.png');
		this._up__img.setAttribute('style','position: absolute;top: 0px;left: 0px;');
		me.player.checkLoaded.push(this._up__img);
		this._up.appendChild(this._up__img);
		this._up.onmouseover=function () {
			me.player.changeTilt(1,true);
			me._up.style[domTransition]='none';
			me._up.style.opacity='1';
			me._up.style.visibility=me._up.ggVisible?'inherit':'hidden';
			me._up__img.src=basePath + 'images/up__o.png';
		}
		this._up.onmouseout=function () {
			me._up.style[domTransition]='none';
			me._up.style.opacity='0.3';
			me._up.style.visibility=me._up.ggVisible?'inherit':'hidden';
			me._up__img.src=basePath + 'images/up.png';
			me.elementMouseDown['up']=false;
		}
		this._up.onmousedown=function () {
			me.elementMouseDown['up']=true;
		}
		this._up.onmouseup=function () {
			me.elementMouseDown['up']=false;
		}
		this._up.ontouchend=function () {
			me.elementMouseDown['up']=false;
		}
		this._gor.appendChild(this._up);
		this.divSkin.appendChild(this._gor);
		this._opomnik=document.createElement('div');
		this._opomnik.ggId='Opomnik'
		this._opomnik.ggParameter={ rx:0,ry:0,a:0,sx:1,sy:1 };
		this._opomnik.ggVisible=true;
		this._opomnik.ggUpdatePosition=function() {
			this.style[domTransition]='none';
			if (this.parentNode) {
				w=this.parentNode.offsetWidth;
				this.style.left=(-420 + w) + 'px';
				h=this.parentNode.offsetHeight;
				this.style.top=(-81 + h) + 'px';
			}
		}
		hs ='position:absolute;';
		hs+='left: -420px;';
		hs+='top:  -81px;';
		hs+='width: 303px;';
		hs+='height: 20px;';
		hs+=cssPrefix + 'transform-origin: 50% 50%;';
		hs+='visibility: inherit;';
		hs+='border: 0px solid #000000;';
		this._opomnik.setAttribute('style',hs);
		this._full_screen=document.createElement('div');
		this._full_screen.ggId='FULL SCREEN'
		this._full_screen.ggParameter={ rx:0,ry:0,a:0,sx:1,sy:1 };
		this._full_screen.ggVisible=true;
		hs ='position:absolute;';
		hs+='left: 45px;';
		hs+='top:  0px;';
		hs+='width: auto;';
		hs+='height: auto;';
		hs+=cssPrefix + 'transform-origin: 50% 50%;';
		hs+='visibility: inherit;';
		hs+='border: 0px solid #000000;';
		hs+='color: #ffffff;';
		hs+='text-align: left;';
		hs+='white-space: nowrap;';
		hs+='padding: 0px 1px 0px 1px;'
		hs+='overflow: hidden;';
		this._full_screen.setAttribute('style',hs);
		this._full_screen.innerHTML="";
		this._opomnik.appendChild(this._full_screen);
		this.divSkin.appendChild(this._opomnik);
		this._navigacija_desno=document.createElement('div');
		this._navigacija_desno.ggId='Navigacija_Desno'
		this._navigacija_desno.ggParameter={ rx:0,ry:0,a:0,sx:1,sy:1 };
		this._navigacija_desno.ggVisible=true;
		this._navigacija_desno.ggUpdatePosition=function() {
			this.style[domTransition]='none';
			if (this.parentNode) {
				w=this.parentNode.offsetWidth;
				this.style.left=(-160 + w) + 'px';
				h=this.parentNode.offsetHeight;
				this.style.top=(-131 + h) + 'px';
			}
		}
		hs ='position:absolute;';
		hs+='left: -160px;';
		hs+='top:  -131px;';
		hs+='width: 158px;';
		hs+='height: 129px;';
		hs+=cssPrefix + 'transform-origin: 50% 50%;';
		hs+='visibility: inherit;';
		hs+='border: 0px solid #000000;';
		this._navigacija_desno.setAttribute('style',hs);
		this._zoom_in=document.createElement('div');
		this._zoom_in.ggId='zoom in'
		this._zoom_in.ggParameter={ rx:0,ry:0,a:0,sx:1,sy:1 };
		this._zoom_in.ggVisible=true;
		hs ='position:absolute;';
		hs+='left: 110px;';
		hs+='top:  30px;';
		hs+='width: 40px;';
		hs+='height: 40px;';
		hs+=cssPrefix + 'transform-origin: 50% 50%;';
		hs+='opacity: 0.5;';
		hs+='visibility: inherit;';
		hs+='cursor: pointer;';
		this._zoom_in.setAttribute('style',hs);
		this._zoom_in__img=document.createElement('img');
		this._zoom_in__img.setAttribute('src',basePath + 'images/zoom_in.png');
		this._zoom_in__img.setAttribute('style','position: absolute;top: 0px;left: 0px;');
		me.player.checkLoaded.push(this._zoom_in__img);
		this._zoom_in.appendChild(this._zoom_in__img);
		this._zoom_in.onclick=function () {
			me.player.playSound("_panosound_0","");
		}
		this._zoom_in.onmouseover=function () {
			if (me.player.transitionsDisabled) {
				me._zoom_in.style[domTransition]='none';
			} else {
				me._zoom_in.style[domTransition]='all 500ms ease-out 0ms';
			}
			me._zoom_in.ggParameter.sx=1.3;me._zoom_in.ggParameter.sy=1.3;
			me._zoom_in.style[domTransform]=parameterToTransform(me._zoom_in.ggParameter);
			me._full_screen.innerHTML="POVE\u010cAVA :: ZOOM";
			if (me._full_screen.ggUpdateText) {
				me._full_screen.ggUpdateText=function() {
					me._full_screen.innerHTML="POVE\u010cAVA :: ZOOM";
				}
			}
			me._full_screen.style[domTransition]='none';
			me._full_screen.style.visibility='inherit';
			me._full_screen.ggVisible=true;
			if (me.player.transitionsDisabled) {
				me._zoom_in.style[domTransition]='none';
			} else {
				me._zoom_in.style[domTransition]='all 500ms ease-out 0ms';
			}
			me._zoom_in.style.opacity='1';
			me._zoom_in.style.visibility=me._zoom_in.ggVisible?'inherit':'hidden';
		}
		this._zoom_in.onmouseout=function () {
			if (me.player.transitionsDisabled) {
				me._zoom_in.style[domTransition]='none';
			} else {
				me._zoom_in.style[domTransition]='all 500ms ease-out 0ms';
			}
			me._zoom_in.ggParameter.sx=1;me._zoom_in.ggParameter.sy=1;
			me._zoom_in.style[domTransform]=parameterToTransform(me._zoom_in.ggParameter);
			me._full_screen.style[domTransition]='none';
			me._full_screen.style.visibility='hidden';
			me._full_screen.ggVisible=false;
			if (me.player.transitionsDisabled) {
				me._zoom_in.style[domTransition]='none';
			} else {
				me._zoom_in.style[domTransition]='all 500ms ease-out 0ms';
			}
			me._zoom_in.style.opacity='0.5';
			me._zoom_in.style.visibility=me._zoom_in.ggVisible?'inherit':'hidden';
			me.elementMouseDown['zoom_in']=false;
		}
		this._zoom_in.onmousedown=function () {
			me.elementMouseDown['zoom_in']=true;
		}
		this._zoom_in.onmouseup=function () {
			me.elementMouseDown['zoom_in']=false;
		}
		this._zoom_in.ontouchend=function () {
			me.elementMouseDown['zoom_in']=false;
		}
		this._navigacija_desno.appendChild(this._zoom_in);
		this._zoom_out=document.createElement('div');
		this._zoom_out.ggId='zoom out'
		this._zoom_out.ggParameter={ rx:0,ry:0,a:0,sx:1,sy:1 };
		this._zoom_out.ggVisible=true;
		hs ='position:absolute;';
		hs+='left: 110px;';
		hs+='top:  80px;';
		hs+='width: 40px;';
		hs+='height: 40px;';
		hs+=cssPrefix + 'transform-origin: 50% 50%;';
		hs+='opacity: 0.5;';
		hs+='visibility: inherit;';
		hs+='cursor: pointer;';
		this._zoom_out.setAttribute('style',hs);
		this._zoom_out__img=document.createElement('img');
		this._zoom_out__img.setAttribute('src',basePath + 'images/zoom_out.png');
		this._zoom_out__img.setAttribute('style','position: absolute;top: 0px;left: 0px;');
		me.player.checkLoaded.push(this._zoom_out__img);
		this._zoom_out.appendChild(this._zoom_out__img);
		this._zoom_out.onmouseover=function () {
			if (me.player.transitionsDisabled) {
				me._zoom_out.style[domTransition]='none';
			} else {
				me._zoom_out.style[domTransition]='all 500ms ease-out 0ms';
			}
			me._zoom_out.style.opacity='1';
			me._zoom_out.style.visibility=me._zoom_out.ggVisible?'inherit':'hidden';
		}
		this._zoom_out.onmouseout=function () {
			if (me.player.transitionsDisabled) {
				me._zoom_out.style[domTransition]='none';
			} else {
				me._zoom_out.style[domTransition]='all 500ms ease-out 0ms';
			}
			me._zoom_out.style.opacity='0.5';
			me._zoom_out.style.visibility=me._zoom_out.ggVisible?'inherit':'hidden';
			me.elementMouseDown['zoom_out']=false;
		}
		this._zoom_out.onmousedown=function () {
			me.elementMouseDown['zoom_out']=true;
		}
		this._zoom_out.onmouseup=function () {
			me.elementMouseDown['zoom_out']=false;
		}
		this._zoom_out.ontouchend=function () {
			me.elementMouseDown['zoom_out']=false;
		}
		this._navigacija_desno.appendChild(this._zoom_out);
		this.divSkin.appendChild(this._navigacija_desno);
		this._navigacija_levo=document.createElement('div');
		this._navigacija_levo.ggId='Navigacija_Levo'
		this._navigacija_levo.ggParameter={ rx:0,ry:0,a:0,sx:1,sy:1 };
		this._navigacija_levo.ggVisible=true;
		this._navigacija_levo.ggUpdatePosition=function() {
			this.style[domTransition]='none';
			if (this.parentNode) {
				h=this.parentNode.offsetHeight;
				this.style.top=(-51 + h) + 'px';
			}
		}
		hs ='position:absolute;';
		hs+='left: 10px;';
		hs+='top:  -51px;';
		hs+='width: 167px;';
		hs+='height: 42px;';
		hs+=cssPrefix + 'transform-origin: 50% 50%;';
		hs+='visibility: inherit;';
		hs+='border: 0px solid #000000;';
		this._navigacija_levo.setAttribute('style',hs);
		this._nacinpremikanja=document.createElement('div');
		this._nacinpremikanja.ggId='nacinpremikanja'
		this._nacinpremikanja.ggParameter={ rx:0,ry:0,a:0,sx:1,sy:1 };
		this._nacinpremikanja.ggVisible=true;
		hs ='position:absolute;';
		hs+='left: 110px;';
		hs+='top:  0px;';
		hs+='width: 40px;';
		hs+='height: 40px;';
		hs+=cssPrefix + 'transform-origin: 50% 50%;';
		hs+='opacity: 0.7;';
		hs+='visibility: inherit;';
		hs+='cursor: pointer;';
		this._nacinpremikanja.setAttribute('style',hs);
		this._nacinpremikanja__img=document.createElement('img');
		this._nacinpremikanja__img.setAttribute('src',basePath + 'images/nacinpremikanja.png');
		this._nacinpremikanja__img.setAttribute('style','position: absolute;top: 0px;left: 0px;');
		me.player.checkLoaded.push(this._nacinpremikanja__img);
		this._nacinpremikanja.appendChild(this._nacinpremikanja__img);
		this._nacinpremikanja.onclick=function () {
			me.player.changeViewMode(2);
			me._nacinpremikanja2.style[domTransition]='none';
			me._nacinpremikanja2.style.visibility='inherit';
			me._nacinpremikanja2.ggVisible=true;
			me._nacinpremikanja.style[domTransition]='none';
			me._nacinpremikanja.style.visibility='hidden';
			me._nacinpremikanja.ggVisible=false;
		}
		this._nacinpremikanja.onmouseover=function () {
			me._full_screen.innerHTML="NA\u010cIN PREMIKA :: MOVE MODE";
			if (me._full_screen.ggUpdateText) {
				me._full_screen.ggUpdateText=function() {
					me._full_screen.innerHTML="NA\u010cIN PREMIKA :: MOVE MODE";
				}
			}
			me._full_screen.style[domTransition]='none';
			me._full_screen.style.visibility='inherit';
			me._full_screen.ggVisible=true;
			if (me.player.transitionsDisabled) {
				me._nacinpremikanja.style[domTransition]='none';
			} else {
				me._nacinpremikanja.style[domTransition]='all 500ms ease-out 0ms';
			}
			me._nacinpremikanja.style.opacity='1';
			me._nacinpremikanja.style.visibility=me._nacinpremikanja.ggVisible?'inherit':'hidden';
		}
		this._nacinpremikanja.onmouseout=function () {
			me._full_screen.style[domTransition]='none';
			me._full_screen.style.visibility='hidden';
			me._full_screen.ggVisible=false;
			if (me.player.transitionsDisabled) {
				me._nacinpremikanja.style[domTransition]='none';
			} else {
				me._nacinpremikanja.style[domTransition]='all 500ms ease-out 0ms';
			}
			me._nacinpremikanja.style.opacity='0.8';
			me._nacinpremikanja.style.visibility=me._nacinpremikanja.ggVisible?'inherit':'hidden';
		}
		this._navigacija_levo.appendChild(this._nacinpremikanja);
		this._nacinpremikanja2=document.createElement('div');
		this._nacinpremikanja2.ggId='nacinpremikanja2'
		this._nacinpremikanja2.ggParameter={ rx:0,ry:0,a:0,sx:1,sy:1 };
		this._nacinpremikanja2.ggVisible=false;
		hs ='position:absolute;';
		hs+='left: 110px;';
		hs+='top:  0px;';
		hs+='width: 40px;';
		hs+='height: 40px;';
		hs+=cssPrefix + 'transform-origin: 50% 50%;';
		hs+='opacity: 0.7;';
		hs+='visibility: hidden;';
		hs+='cursor: pointer;';
		this._nacinpremikanja2.setAttribute('style',hs);
		this._nacinpremikanja2__img=document.createElement('img');
		this._nacinpremikanja2__img.setAttribute('src',basePath + 'images/nacinpremikanja2.png');
		this._nacinpremikanja2__img.setAttribute('style','position: absolute;top: 0px;left: 0px;');
		me.player.checkLoaded.push(this._nacinpremikanja2__img);
		this._nacinpremikanja2.appendChild(this._nacinpremikanja2__img);
		this._nacinpremikanja2.onclick=function () {
			me.player.changeViewMode(2);
			me._nacinpremikanja2.style[domTransition]='none';
			me._nacinpremikanja2.style.visibility='hidden';
			me._nacinpremikanja2.ggVisible=false;
			me._nacinpremikanja.style[domTransition]='none';
			me._nacinpremikanja.style.visibility='inherit';
			me._nacinpremikanja.ggVisible=true;
		}
		this._nacinpremikanja2.onmouseover=function () {
			me._full_screen.innerHTML="NA\u010cIN PREMIKA :: MOVE MODE";
			if (me._full_screen.ggUpdateText) {
				me._full_screen.ggUpdateText=function() {
					me._full_screen.innerHTML="NA\u010cIN PREMIKA :: MOVE MODE";
				}
			}
			me._full_screen.style[domTransition]='none';
			me._full_screen.style.visibility='inherit';
			me._full_screen.ggVisible=true;
			if (me.player.transitionsDisabled) {
				me._nacinpremikanja2.style[domTransition]='none';
			} else {
				me._nacinpremikanja2.style[domTransition]='all 500ms ease-out 0ms';
			}
			me._nacinpremikanja2.style.opacity='1';
			me._nacinpremikanja2.style.visibility=me._nacinpremikanja2.ggVisible?'inherit':'hidden';
		}
		this._nacinpremikanja2.onmouseout=function () {
			me._full_screen.style[domTransition]='none';
			me._full_screen.style.visibility='hidden';
			me._full_screen.ggVisible=false;
			if (me.player.transitionsDisabled) {
				me._nacinpremikanja2.style[domTransition]='none';
			} else {
				me._nacinpremikanja2.style[domTransition]='all 500ms ease-out 0ms';
			}
			me._nacinpremikanja2.style.opacity='0.8';
			me._nacinpremikanja2.style.visibility=me._nacinpremikanja2.ggVisible?'inherit':'hidden';
		}
		this._navigacija_levo.appendChild(this._nacinpremikanja2);
		this._info=document.createElement('div');
		this._info.ggId='info'
		this._info.ggParameter={ rx:0,ry:0,a:0,sx:1,sy:1 };
		this._info.ggVisible=true;
		hs ='position:absolute;';
		hs+='left: 60px;';
		hs+='top:  0px;';
		hs+='width: 40px;';
		hs+='height: 40px;';
		hs+=cssPrefix + 'transform-origin: 50% 50%;';
		hs+='opacity: 0.5;';
		hs+='visibility: inherit;';
		hs+='cursor: pointer;';
		this._info.setAttribute('style',hs);
		this._info__img=document.createElement('img');
		this._info__img.setAttribute('src',basePath + 'images/info.png');
		this._info__img.setAttribute('style','position: absolute;top: 0px;left: 0px;');
		me.player.checkLoaded.push(this._info__img);
		this._info.appendChild(this._info__img);
		this._info.onclick=function () {
			flag=(me._userdata.style.visibility=='hidden');
			me._userdata.style[domTransition]='none';
			me._userdata.style.visibility=flag?'inherit':'hidden';
			me._userdata.ggVisible=flag;
		}
		this._info.onmouseover=function () {
			me._full_screen.innerHTML="INFORMACIJA :: INFO";
			if (me._full_screen.ggUpdateText) {
				me._full_screen.ggUpdateText=function() {
					me._full_screen.innerHTML="INFORMACIJA :: INFO";
				}
			}
			me._full_screen.style[domTransition]='none';
			me._full_screen.style.visibility='inherit';
			me._full_screen.ggVisible=true;
			if (me.player.transitionsDisabled) {
				me._info.style[domTransition]='none';
			} else {
				me._info.style[domTransition]='all 500ms ease-out 0ms';
			}
			me._info.style.opacity='1';
			me._info.style.visibility=me._info.ggVisible?'inherit':'hidden';
			me._info__img.src=basePath + 'images/info__o.png';
		}
		this._info.onmouseout=function () {
			me._full_screen.style[domTransition]='none';
			me._full_screen.style.visibility='hidden';
			me._full_screen.ggVisible=false;
			if (me.player.transitionsDisabled) {
				me._info.style[domTransition]='none';
			} else {
				me._info.style[domTransition]='all 500ms ease-out 0ms';
			}
			me._info.style.opacity='0.5';
			me._info.style.visibility=me._info.ggVisible?'inherit':'hidden';
			me._info__img.src=basePath + 'images/info.png';
		}
		this._navigacija_levo.appendChild(this._info);
		this._prehodi=document.createElement('div');
		this._prehodi.ggId='PREHODI'
		this._prehodi.ggParameter={ rx:0,ry:0,a:0,sx:1,sy:1 };
		this._prehodi.ggVisible=true;
		hs ='position:absolute;';
		hs+='left: 0px;';
		hs+='top:  0px;';
		hs+='width: 40px;';
		hs+='height: 40px;';
		hs+=cssPrefix + 'transform-origin: 50% 50%;';
		hs+='opacity: 0.6;';
		hs+='visibility: inherit;';
		hs+='cursor: pointer;';
		this._prehodi.setAttribute('style',hs);
		this._prehodi__img=document.createElement('img');
		this._prehodi__img.setAttribute('src',basePath + 'images/prehodi.png');
		this._prehodi__img.setAttribute('style','position: absolute;top: 0px;left: 0px;');
		me.player.checkLoaded.push(this._prehodi__img);
		this._prehodi.appendChild(this._prehodi__img);
		this._prehodi.onclick=function () {
			var list=me.findElements('kvadrat',false);
			if (list.length>0) {
				var e=list[0];
				flag=e.ggOpacitiyActive;
			}
			while(list.length>0) {
				var e=list.pop();
				if (me.player.transitionsDisabled) {
					e.style[domTransition]='none';
				} else {
					e.style[domTransition]='all 500ms ease-out 0ms';
				}
				if (flag) {
					e.style.opacity='1';
					e.style.visibility=e.ggVisible?'inherit':'hidden';
				} else {
					e.style.opacity='0';
					e.style.visibility='hidden';
				}
				e.ggOpacitiyActive=!flag;
			}
			var list=me.findElements('naprej',false);
			if (list.length>0) {
				var e=list[0];
				flag=e.ggOpacitiyActive;
			}
			while(list.length>0) {
				var e=list.pop();
				if (me.player.transitionsDisabled) {
					e.style[domTransition]='none';
				} else {
					e.style[domTransition]='all 500ms ease-out 0ms';
				}
				if (flag) {
					e.style.opacity='1';
					e.style.visibility=e.ggVisible?'inherit':'hidden';
				} else {
					e.style.opacity='0';
					e.style.visibility='hidden';
				}
				e.ggOpacitiyActive=!flag;
			}
			var list=me.findElements('up',false);
			if (list.length>0) {
				var e=list[0];
				flag=e.ggOpacitiyActive;
			}
			while(list.length>0) {
				var e=list.pop();
				if (me.player.transitionsDisabled) {
					e.style[domTransition]='none';
				} else {
					e.style[domTransition]='all 500ms ease-out 0ms';
				}
				if (flag) {
					e.style.opacity='0.2';
					e.style.visibility=e.ggVisible?'inherit':'hidden';
				} else {
					e.style.opacity='0';
					e.style.visibility='hidden';
				}
				e.ggOpacitiyActive=!flag;
			}
			var list=me.findElements('down',false);
			if (list.length>0) {
				var e=list[0];
				flag=e.ggOpacitiyActive;
			}
			while(list.length>0) {
				var e=list.pop();
				if (me.player.transitionsDisabled) {
					e.style[domTransition]='none';
				} else {
					e.style[domTransition]='all 500ms ease-out 0ms';
				}
				if (flag) {
					e.style.opacity='0.2';
					e.style.visibility=e.ggVisible?'inherit':'hidden';
				} else {
					e.style.opacity='0';
					e.style.visibility='hidden';
				}
				e.ggOpacitiyActive=!flag;
			}
			var list=me.findElements('left',false);
			if (list.length>0) {
				var e=list[0];
				flag=e.ggOpacitiyActive;
			}
			while(list.length>0) {
				var e=list.pop();
				if (me.player.transitionsDisabled) {
					e.style[domTransition]='none';
				} else {
					e.style[domTransition]='all 500ms ease-out 0ms';
				}
				if (flag) {
					e.style.opacity='0.2';
					e.style.visibility=e.ggVisible?'inherit':'hidden';
				} else {
					e.style.opacity='0';
					e.style.visibility='hidden';
				}
				e.ggOpacitiyActive=!flag;
			}
			var list=me.findElements('right',false);
			if (list.length>0) {
				var e=list[0];
				flag=e.ggOpacitiyActive;
			}
			while(list.length>0) {
				var e=list.pop();
				if (me.player.transitionsDisabled) {
					e.style[domTransition]='none';
				} else {
					e.style[domTransition]='all 500ms ease-out 0ms';
				}
				if (flag) {
					e.style.opacity='0.2';
					e.style.visibility=e.ggVisible?'inherit':'hidden';
				} else {
					e.style.opacity='0';
					e.style.visibility='hidden';
				}
				e.ggOpacitiyActive=!flag;
			}
			var list=me.findElements('info',false);
			if (list.length>0) {
				var e=list[0];
				flag=e.ggOpacitiyActive;
			}
			while(list.length>0) {
				var e=list.pop();
				if (me.player.transitionsDisabled) {
					e.style[domTransition]='none';
				} else {
					e.style[domTransition]='all 500ms ease-out 0ms';
				}
				if (flag) {
					e.style.opacity='0.5';
					e.style.visibility=e.ggVisible?'inherit':'hidden';
				} else {
					e.style.opacity='0';
					e.style.visibility='hidden';
				}
				e.ggOpacitiyActive=!flag;
			}
			var list=me.findElements('naprej_levo',false);
			if (list.length>0) {
				var e=list[0];
				flag=e.ggOpacitiyActive;
			}
			while(list.length>0) {
				var e=list.pop();
				if (me.player.transitionsDisabled) {
					e.style[domTransition]='none';
				} else {
					e.style[domTransition]='all 500ms ease-out 0ms';
				}
				if (flag) {
					e.style.opacity='1';
					e.style.visibility=e.ggVisible?'inherit':'hidden';
				} else {
					e.style.opacity='0';
					e.style.visibility='hidden';
				}
				e.ggOpacitiyActive=!flag;
			}
			flag=me._navigacija_desno.ggOpacitiyActive;
			if (me.player.transitionsDisabled) {
				me._navigacija_desno.style[domTransition]='none';
			} else {
				me._navigacija_desno.style[domTransition]='all 500ms ease-out 0ms';
			}
			if (flag) {
				me._navigacija_desno.style.opacity='1';
				me._navigacija_desno.style.visibility=me._navigacija_desno.ggVisible?'inherit':'hidden';
			} else {
				me._navigacija_desno.style.opacity='0';
				me._navigacija_desno.style.visibility='hidden';
			}
			me._navigacija_desno.ggOpacitiyActive=!flag;
			me._odpriprehodi.style[domTransition]='none';
			me._odpriprehodi.style.visibility='inherit';
			me._odpriprehodi.ggVisible=true;
			me._prehodi.style[domTransition]='none';
			me._prehodi.style.visibility='hidden';
			me._prehodi.ggVisible=false;
			flag=me._nacinpremikanja.ggOpacitiyActive;
			if (me.player.transitionsDisabled) {
				me._nacinpremikanja.style[domTransition]='none';
			} else {
				me._nacinpremikanja.style[domTransition]='all 500ms ease-out 0ms';
			}
			if (flag) {
				me._nacinpremikanja.style.opacity='0.7';
				me._nacinpremikanja.style.visibility=me._nacinpremikanja.ggVisible?'inherit':'hidden';
			} else {
				me._nacinpremikanja.style.opacity='0';
				me._nacinpremikanja.style.visibility='hidden';
			}
			me._nacinpremikanja.ggOpacitiyActive=!flag;
			flag=me._nacinpremikanja2.ggOpacitiyActive;
			if (me.player.transitionsDisabled) {
				me._nacinpremikanja2.style[domTransition]='none';
			} else {
				me._nacinpremikanja2.style[domTransition]='all 500ms ease-out 0ms';
			}
			if (flag) {
				me._nacinpremikanja2.style.opacity='0.7';
				me._nacinpremikanja2.style.visibility=me._nacinpremikanja2.ggVisible?'inherit':'hidden';
			} else {
				me._nacinpremikanja2.style.opacity='0';
				me._nacinpremikanja2.style.visibility='hidden';
			}
			me._nacinpremikanja2.ggOpacitiyActive=!flag;
		}
		this._prehodi.onmouseover=function () {
			me._full_screen.innerHTML="ONEMOGO\u010cI PREHODE :: DISABLE HOT SPOTS";
			if (me._full_screen.ggUpdateText) {
				me._full_screen.ggUpdateText=function() {
					me._full_screen.innerHTML="ONEMOGO\u010cI PREHODE :: DISABLE HOT SPOTS";
				}
			}
			me._full_screen.style[domTransition]='none';
			me._full_screen.style.visibility='inherit';
			me._full_screen.ggVisible=true;
			if (me.player.transitionsDisabled) {
				me._prehodi.style[domTransition]='none';
			} else {
				me._prehodi.style[domTransition]='all 500ms ease-out 0ms';
			}
			me._prehodi.style.opacity='1';
			me._prehodi.style.visibility=me._prehodi.ggVisible?'inherit':'hidden';
			me._prehodi__img.src=basePath + 'images/prehodi__o.png';
		}
		this._prehodi.onmouseout=function () {
			me._full_screen.style[domTransition]='none';
			me._full_screen.style.visibility='hidden';
			me._full_screen.ggVisible=false;
			if (me.player.transitionsDisabled) {
				me._prehodi.style[domTransition]='none';
			} else {
				me._prehodi.style[domTransition]='all 500ms ease-out 0ms';
			}
			me._prehodi.style.opacity='0.6';
			me._prehodi.style.visibility=me._prehodi.ggVisible?'inherit':'hidden';
			me._prehodi__img.src=basePath + 'images/prehodi.png';
		}
		this._prehodi.onmousedown=function () {
			me._prehodi__img.src=basePath + 'images/prehodi__a.png';
		}
		this._prehodi.onmouseup=function () {
			me._prehodi__img.src=basePath + 'images/prehodi.png';
		}
		this._navigacija_levo.appendChild(this._prehodi);
		this._odpriprehodi=document.createElement('div');
		this._odpriprehodi.ggId='odpriprehodi'
		this._odpriprehodi.ggParameter={ rx:0,ry:0,a:0,sx:1,sy:1 };
		this._odpriprehodi.ggVisible=false;
		hs ='position:absolute;';
		hs+='left: 0px;';
		hs+='top:  0px;';
		hs+='width: 40px;';
		hs+='height: 40px;';
		hs+=cssPrefix + 'transform-origin: 50% 50%;';
		hs+='opacity: 0.6;';
		hs+='visibility: hidden;';
		hs+='cursor: pointer;';
		this._odpriprehodi.setAttribute('style',hs);
		this._odpriprehodi__img=document.createElement('img');
		this._odpriprehodi__img.setAttribute('src',basePath + 'images/odpriprehodi.png');
		this._odpriprehodi__img.setAttribute('style','position: absolute;top: 0px;left: 0px;');
		me.player.checkLoaded.push(this._odpriprehodi__img);
		this._odpriprehodi.appendChild(this._odpriprehodi__img);
		this._odpriprehodi.onclick=function () {
			var list=me.findElements('kvadrat',false);
			if (list.length>0) {
				var e=list[0];
				flag=e.ggOpacitiyActive;
			}
			while(list.length>0) {
				var e=list.pop();
				if (me.player.transitionsDisabled) {
					e.style[domTransition]='none';
				} else {
					e.style[domTransition]='all 500ms ease-out 0ms';
				}
				if (flag) {
					e.style.opacity='1';
					e.style.visibility=e.ggVisible?'inherit':'hidden';
				} else {
					e.style.opacity='0';
					e.style.visibility='hidden';
				}
				e.ggOpacitiyActive=!flag;
			}
			var list=me.findElements('naprej',false);
			if (list.length>0) {
				var e=list[0];
				flag=e.ggOpacitiyActive;
			}
			while(list.length>0) {
				var e=list.pop();
				if (me.player.transitionsDisabled) {
					e.style[domTransition]='none';
				} else {
					e.style[domTransition]='all 500ms ease-out 0ms';
				}
				if (flag) {
					e.style.opacity='1';
					e.style.visibility=e.ggVisible?'inherit':'hidden';
				} else {
					e.style.opacity='0';
					e.style.visibility='hidden';
				}
				e.ggOpacitiyActive=!flag;
			}
			var list=me.findElements('up',false);
			if (list.length>0) {
				var e=list[0];
				flag=e.ggOpacitiyActive;
			}
			while(list.length>0) {
				var e=list.pop();
				if (me.player.transitionsDisabled) {
					e.style[domTransition]='none';
				} else {
					e.style[domTransition]='all 500ms ease-out 0ms';
				}
				if (flag) {
					e.style.opacity='0.2';
					e.style.visibility=e.ggVisible?'inherit':'hidden';
				} else {
					e.style.opacity='0';
					e.style.visibility='hidden';
				}
				e.ggOpacitiyActive=!flag;
			}
			var list=me.findElements('down',false);
			if (list.length>0) {
				var e=list[0];
				flag=e.ggOpacitiyActive;
			}
			while(list.length>0) {
				var e=list.pop();
				if (me.player.transitionsDisabled) {
					e.style[domTransition]='none';
				} else {
					e.style[domTransition]='all 500ms ease-out 0ms';
				}
				if (flag) {
					e.style.opacity='0.2';
					e.style.visibility=e.ggVisible?'inherit':'hidden';
				} else {
					e.style.opacity='0';
					e.style.visibility='hidden';
				}
				e.ggOpacitiyActive=!flag;
			}
			var list=me.findElements('left',false);
			if (list.length>0) {
				var e=list[0];
				flag=e.ggOpacitiyActive;
			}
			while(list.length>0) {
				var e=list.pop();
				if (me.player.transitionsDisabled) {
					e.style[domTransition]='none';
				} else {
					e.style[domTransition]='all 500ms ease-out 0ms';
				}
				if (flag) {
					e.style.opacity='0.2';
					e.style.visibility=e.ggVisible?'inherit':'hidden';
				} else {
					e.style.opacity='0';
					e.style.visibility='hidden';
				}
				e.ggOpacitiyActive=!flag;
			}
			var list=me.findElements('right',false);
			if (list.length>0) {
				var e=list[0];
				flag=e.ggOpacitiyActive;
			}
			while(list.length>0) {
				var e=list.pop();
				if (me.player.transitionsDisabled) {
					e.style[domTransition]='none';
				} else {
					e.style[domTransition]='all 500ms ease-out 0ms';
				}
				if (flag) {
					e.style.opacity='0.2';
					e.style.visibility=e.ggVisible?'inherit':'hidden';
				} else {
					e.style.opacity='0';
					e.style.visibility='hidden';
				}
				e.ggOpacitiyActive=!flag;
			}
			var list=me.findElements('info',false);
			if (list.length>0) {
				var e=list[0];
				flag=e.ggOpacitiyActive;
			}
			while(list.length>0) {
				var e=list.pop();
				if (me.player.transitionsDisabled) {
					e.style[domTransition]='none';
				} else {
					e.style[domTransition]='all 500ms ease-out 0ms';
				}
				if (flag) {
					e.style.opacity='0.5';
					e.style.visibility=e.ggVisible?'inherit':'hidden';
				} else {
					e.style.opacity='0';
					e.style.visibility='hidden';
				}
				e.ggOpacitiyActive=!flag;
			}
			var list=me.findElements('naprej_levo',false);
			if (list.length>0) {
				var e=list[0];
				flag=e.ggOpacitiyActive;
			}
			while(list.length>0) {
				var e=list.pop();
				if (me.player.transitionsDisabled) {
					e.style[domTransition]='none';
				} else {
					e.style[domTransition]='all 500ms ease-out 0ms';
				}
				if (flag) {
					e.style.opacity='1';
					e.style.visibility=e.ggVisible?'inherit':'hidden';
				} else {
					e.style.opacity='0';
					e.style.visibility='hidden';
				}
				e.ggOpacitiyActive=!flag;
			}
			flag=me._navigacija_desno.ggOpacitiyActive;
			if (me.player.transitionsDisabled) {
				me._navigacija_desno.style[domTransition]='none';
			} else {
				me._navigacija_desno.style[domTransition]='all 500ms ease-out 0ms';
			}
			if (flag) {
				me._navigacija_desno.style.opacity='1';
				me._navigacija_desno.style.visibility=me._navigacija_desno.ggVisible?'inherit':'hidden';
			} else {
				me._navigacija_desno.style.opacity='0';
				me._navigacija_desno.style.visibility='hidden';
			}
			me._navigacija_desno.ggOpacitiyActive=!flag;
			me._odpriprehodi.style[domTransition]='none';
			me._odpriprehodi.style.visibility='hidden';
			me._odpriprehodi.ggVisible=false;
			me._prehodi.style[domTransition]='none';
			me._prehodi.style.visibility='inherit';
			me._prehodi.ggVisible=true;
			flag=me._nacinpremikanja.ggOpacitiyActive;
			if (me.player.transitionsDisabled) {
				me._nacinpremikanja.style[domTransition]='none';
			} else {
				me._nacinpremikanja.style[domTransition]='all 500ms ease-out 0ms';
			}
			if (flag) {
				me._nacinpremikanja.style.opacity='0.7';
				me._nacinpremikanja.style.visibility=me._nacinpremikanja.ggVisible?'inherit':'hidden';
			} else {
				me._nacinpremikanja.style.opacity='0';
				me._nacinpremikanja.style.visibility='hidden';
			}
			me._nacinpremikanja.ggOpacitiyActive=!flag;
			flag=me._nacinpremikanja2.ggOpacitiyActive;
			if (me.player.transitionsDisabled) {
				me._nacinpremikanja2.style[domTransition]='none';
			} else {
				me._nacinpremikanja2.style[domTransition]='all 500ms ease-out 0ms';
			}
			if (flag) {
				me._nacinpremikanja2.style.opacity='0.7';
				me._nacinpremikanja2.style.visibility=me._nacinpremikanja2.ggVisible?'inherit':'hidden';
			} else {
				me._nacinpremikanja2.style.opacity='0';
				me._nacinpremikanja2.style.visibility='hidden';
			}
			me._nacinpremikanja2.ggOpacitiyActive=!flag;
			me._desno.style[domTransition]='none';
			me._desno.style.visibility='inherit';
			me._desno.ggVisible=true;
			me._dol.style[domTransition]='none';
			me._dol.style.visibility='inherit';
			me._dol.ggVisible=true;
			me._levo.style[domTransition]='none';
			me._levo.style.visibility='inherit';
			me._levo.ggVisible=true;
			me._gor.style[domTransition]='none';
			me._gor.style.visibility='inherit';
			me._gor.ggVisible=true;
		}
		this._odpriprehodi.onmouseover=function () {
			me._full_screen.innerHTML="OMOGO\u010cI PREHODE :: ENABLE HOT SPOTS";
			if (me._full_screen.ggUpdateText) {
				me._full_screen.ggUpdateText=function() {
					me._full_screen.innerHTML="OMOGO\u010cI PREHODE :: ENABLE HOT SPOTS";
				}
			}
			me._full_screen.style[domTransition]='none';
			me._full_screen.style.visibility='inherit';
			me._full_screen.ggVisible=true;
			if (me.player.transitionsDisabled) {
				me._odpriprehodi.style[domTransition]='none';
			} else {
				me._odpriprehodi.style[domTransition]='all 500ms ease-out 0ms';
			}
			me._odpriprehodi.style.opacity='1';
			me._odpriprehodi.style.visibility=me._odpriprehodi.ggVisible?'inherit':'hidden';
			me._odpriprehodi__img.src=basePath + 'images/odpriprehodi__o.png';
		}
		this._odpriprehodi.onmouseout=function () {
			me._full_screen.style[domTransition]='none';
			me._full_screen.style.visibility='hidden';
			me._full_screen.ggVisible=false;
			if (me.player.transitionsDisabled) {
				me._odpriprehodi.style[domTransition]='none';
			} else {
				me._odpriprehodi.style[domTransition]='all 500ms ease-out 0ms';
			}
			me._odpriprehodi.style.opacity='0.6';
			me._odpriprehodi.style.visibility=me._odpriprehodi.ggVisible?'inherit':'hidden';
			me._odpriprehodi__img.src=basePath + 'images/odpriprehodi.png';
		}
		this._odpriprehodi.onmousedown=function () {
			me._odpriprehodi__img.src=basePath + 'images/odpriprehodi__a.png';
		}
		this._odpriprehodi.onmouseup=function () {
			me._odpriprehodi__img.src=basePath + 'images/odpriprehodi.png';
		}
		this._navigacija_levo.appendChild(this._odpriprehodi);
		this.divSkin.appendChild(this._navigacija_levo);
		this.preloadImages();
		this.divSkin.ggUpdateSize=function(w,h) {
			me.updateSize(me.divSkin);
		}
		this.divSkin.ggViewerInit=function() {
		}
		this.divSkin.ggLoaded=function() {
			me._userdata.style[domTransition]='none';
			me._userdata.style.visibility='hidden';
			me._userdata.ggVisible=false;
			me._loading_image.style[domTransition]='none';
			me._loading_image.style.visibility='hidden';
			me._loading_image.ggVisible=false;
		}
		this.divSkin.ggReLoaded=function() {
		}
		this.divSkin.ggEnterFullscreen=function() {
		}
		this.divSkin.ggExitFullscreen=function() {
		}
		this.skinTimerEvent();
	};
	this.hotspotProxyClick=function(id) {
	}
	this.hotspotProxyOver=function(id) {
	}
	this.hotspotProxyOut=function(id) {
	}
	this.skinTimerEvent=function() {
		setTimeout(function() { me.skinTimerEvent(); }, 10);
		this._title.ggUpdateText();
		this._author.ggUpdateText();
		this._datetime.ggUpdateText();
		this._description.ggUpdateText();
		this._copyright.ggUpdateText();
		var hs='';
		if (me._loading_bar.ggParameter) {
			hs+=parameterToTransform(me._loading_bar.ggParameter) + ' ';
		}
		hs+='scale(' + (1 * me.player.getPercentLoaded() + 0) + ',1.0) ';
		me._loading_bar.style[domTransform]=hs;
		this._loading_text.ggUpdateText();
		if (me.elementMouseDown['right']) {
			me.player.changePan(-1,true);
		}
		if (me.elementMouseDown['left']) {
			me.player.changePan(1,true);
		}
		if (me.elementMouseDown['down']) {
			me.player.changeTilt(-1,true);
		}
		if (me.elementMouseDown['up']) {
			me.player.changeTilt(1,true);
		}
		if (me.elementMouseDown['zoom_in']) {
			me.player.changeFovLog(-1,true);
		}
		if (me.elementMouseDown['zoom_out']) {
			me.player.changeFovLog(1,true);
		}
	};
	function SkinHotspotClass(skinObj,hotspot) {
		var me=this;
		var flag=false;
		this.player=skinObj.player;
		this.skin=skinObj;
		this.hotspot=hotspot;
		this.elementMouseDown=new Array();
		this.elementMouseOver=new Array();
		this.__div=document.createElement('div');
		this.__div.setAttribute('style','position:absolute; left:0px;top:0px;visibility: inherit;');
		
		this.findElements=function(id,regex) {
			var r=new Array();
			var stack=new Array();
			var pat=new RegExp(id,'');
			stack.push(me.__div);
			while(stack.length>0) {
				e=stack.pop();
				if (regex) {
					if (pat.test(e.ggId)) r.push(e);
				} else {
					if (e.ggId==id) r.push(e);
				}
				if (e.hasChildNodes()) {
					for(i=0;i<e.childNodes.length;i++) {
						stack.push(e.childNodes[i]);
					}
				}
			}
			return r;
		}
		
		if (hotspot.skinid=='kvadrat') {
			this.__div=document.createElement('div');
			this.__div.ggId='kvadrat'
			this.__div.ggParameter={ rx:0,ry:0,a:0,sx:1,sy:1 };
			this.__div.ggVisible=true;
			hs ='position:absolute;';
			hs+='left: 230px;';
			hs+='top:  180px;';
			hs+='width: 5px;';
			hs+='height: 5px;';
			hs+=cssPrefix + 'transform-origin: 0% 0%;';
			hs+='visibility: inherit;';
			this.__div.setAttribute('style',hs);
			this.__div.onclick=function () {
				me.player.openUrl(me.hotspot.url,"&ht");
				me.skin.hotspotProxyClick(me.hotspot.id);
			}
			this.__div.onmouseover=function () {
				me.player.hotspot=me.hotspot;
				me.player.openUrl(me.hotspot.url,"&ht");
				me.skin.hotspotProxyOver(me.hotspot.id);
			}
			this.__div.onmouseout=function () {
				me.player.hotspot=me.player.emptyHotspot;
				me.skin.hotspotProxyOut(me.hotspot.id);
			}
			this._slotekst2=document.createElement('div');
			this._slotekst2.ggId='SLOTekst'
			this._slotekst2.ggParameter={ rx:0,ry:0,a:0,sx:1,sy:1 };
			this._slotekst2.ggVisible=false;
			hs ='position:absolute;';
			hs+='left: -115px;';
			hs+='top:  -55px;';
			hs+='width: 225px;';
			hs+='height: auto;';
			hs+=cssPrefix + 'transform-origin: 0% 0%;';
			hs+='opacity: 0;';
			hs+='visibility: hidden;';
			hs+='border: 1px solid #ff0000;';
			hs+='color: #ffffff;';
			hs+='background-color: #3b3b3b;';
			hs+='text-align: left;';
			hs+='white-space: pre-wrap;';
			hs+='padding: 0px 1px 0px 1px;'
			hs+='overflow: hidden;';
			this._slotekst2.setAttribute('style',hs);
			this._slotekst2.innerHTML=me.hotspot.title;
			this._slotekst2.onclick=function () {
				me._slotekst2.style[domTransition]='none';
				me._slotekst2.style.opacity='0';
				me._slotekst2.style.visibility='hidden';
			}
			this.__div.appendChild(this._slotekst2);
			this._slobesedilo2=document.createElement('div');
			this._slobesedilo2.ggId='slobesedilo'
			this._slobesedilo2.ggParameter={ rx:0,ry:0,a:0,sx:0.9,sy:0.9 };
			this._slobesedilo2.ggVisible=true;
			hs ='position:absolute;';
			hs+='left: -20px;';
			hs+='top:  -20px;';
			hs+='width: 40px;';
			hs+='height: 40px;';
			hs+=cssPrefix + 'transform-origin: 50% 50%;';
			hs+=cssPrefix + 'transform: ' + parameterToTransform(this._slobesedilo2.ggParameter) + ';';
			hs+='opacity: 0.5;';
			hs+='visibility: inherit;';
			hs+='cursor: pointer;';
			this._slobesedilo2.setAttribute('style',hs);
			this._slobesedilo2__img=document.createElement('img');
			this._slobesedilo2__img.setAttribute('src',basePath + 'images/slobesedilo2.png');
			this._slobesedilo2__img.setAttribute('style','position: absolute;top: 0px;left: 0px;');
			me.player.checkLoaded.push(this._slobesedilo2__img);
			this._slobesedilo2.appendChild(this._slobesedilo2__img);
			this._slobesedilo2.onmouseover=function () {
				me._slobesedilo2.style[domTransition]='none';
				me._slobesedilo2.style.opacity='1';
				me._slobesedilo2.style.visibility=me._slobesedilo2.ggVisible?'inherit':'hidden';
				if (me.player.transitionsDisabled) {
					me._slobesedilo2.style[domTransition]='none';
				} else {
					me._slobesedilo2.style[domTransition]='all 500ms ease-out 0ms';
				}
				me._slobesedilo2.ggParameter.sx=1;me._slobesedilo2.ggParameter.sy=1;
				me._slobesedilo2.style[domTransform]=parameterToTransform(me._slobesedilo2.ggParameter);
				me._slotekst2.style[domTransition]='none';
				me._slotekst2.style.visibility='inherit';
				me._slotekst2.ggVisible=true;
			}
			this._slobesedilo2.onmouseout=function () {
				me._slobesedilo2.style[domTransition]='none';
				me._slobesedilo2.style.opacity='0.5';
				me._slobesedilo2.style.visibility=me._slobesedilo2.ggVisible?'inherit':'hidden';
				if (me.player.transitionsDisabled) {
					me._slobesedilo2.style[domTransition]='none';
				} else {
					me._slobesedilo2.style[domTransition]='all 500ms ease-out 0ms';
				}
				me._slobesedilo2.ggParameter.sx=0.9;me._slobesedilo2.ggParameter.sy=0.9;
				me._slobesedilo2.style[domTransform]=parameterToTransform(me._slobesedilo2.ggParameter);
			}
			this.__div.appendChild(this._slobesedilo2);
		} else
		if (hotspot.skinid=='naprej') {
			this.__div=document.createElement('div');
			this.__div.ggId='naprej'
			this.__div.ggParameter={ rx:0,ry:0,a:0,sx:1,sy:1 };
			this.__div.ggVisible=true;
			hs ='position:absolute;';
			hs+='left: 230px;';
			hs+='top:  180px;';
			hs+='width: 5px;';
			hs+='height: 5px;';
			hs+=cssPrefix + 'transform-origin: 0% 0%;';
			hs+='visibility: inherit;';
			this.__div.setAttribute('style',hs);
			this.__div.onclick=function () {
				me.player.openUrl(me.hotspot.url,"&ht");
				me.skin.hotspotProxyClick(me.hotspot.id);
			}
			this.__div.onmouseover=function () {
				me.player.hotspot=me.hotspot;
				me.player.openUrl(me.hotspot.url,"&ht");
				me.skin.hotspotProxyOver(me.hotspot.id);
			}
			this.__div.onmouseout=function () {
				me.player.hotspot=me.player.emptyHotspot;
				me.skin.hotspotProxyOut(me.hotspot.id);
			}
			this._slotekst1=document.createElement('div');
			this._slotekst1.ggId='SLOTekst'
			this._slotekst1.ggParameter={ rx:0,ry:0,a:0,sx:1,sy:1 };
			this._slotekst1.ggVisible=false;
			hs ='position:absolute;';
			hs+='left: -115px;';
			hs+='top:  -55px;';
			hs+='width: 225px;';
			hs+='height: auto;';
			hs+=cssPrefix + 'transform-origin: 0% 0%;';
			hs+='opacity: 0;';
			hs+='visibility: hidden;';
			hs+='border: 1px solid #ff0000;';
			hs+='color: #ffffff;';
			hs+='background-color: #3b3b3b;';
			hs+='text-align: left;';
			hs+='white-space: pre-wrap;';
			hs+='padding: 0px 1px 0px 1px;'
			hs+='overflow: hidden;';
			this._slotekst1.setAttribute('style',hs);
			this._slotekst1.innerHTML=me.hotspot.title;
			this._slotekst1.onclick=function () {
				me._slotekst1.style[domTransition]='none';
				me._slotekst1.style.opacity='0';
				me._slotekst1.style.visibility='hidden';
			}
			this.__div.appendChild(this._slotekst1);
			this._slobesedilo1=document.createElement('div');
			this._slobesedilo1.ggId='slobesedilo'
			this._slobesedilo1.ggParameter={ rx:0,ry:0,a:0,sx:0.5,sy:0.5 };
			this._slobesedilo1.ggVisible=true;
			hs ='position:absolute;';
			hs+='left: -20px;';
			hs+='top:  -20px;';
			hs+='width: 100px;';
			hs+='height: 100px;';
			hs+=cssPrefix + 'transform-origin: 50% 50%;';
			hs+=cssPrefix + 'transform: ' + parameterToTransform(this._slobesedilo1.ggParameter) + ';';
			hs+='opacity: 0.8;';
			hs+='visibility: inherit;';
			hs+='cursor: pointer;';
			this._slobesedilo1.setAttribute('style',hs);
			this._slobesedilo1__img=document.createElement('img');
			this._slobesedilo1__img.setAttribute('src',basePath + 'images/slobesedilo1.png');
			this._slobesedilo1__img.setAttribute('style','position: absolute;top: 0px;left: 0px;');
			me.player.checkLoaded.push(this._slobesedilo1__img);
			this._slobesedilo1.appendChild(this._slobesedilo1__img);
			this._slobesedilo1.onmouseover=function () {
				me._slobesedilo1.style[domTransition]='none';
				me._slobesedilo1.style.opacity='1';
				me._slobesedilo1.style.visibility=me._slobesedilo1.ggVisible?'inherit':'hidden';
				if (me.player.transitionsDisabled) {
					me._slobesedilo1.style[domTransition]='none';
				} else {
					me._slobesedilo1.style[domTransition]='all 500ms ease-out 0ms';
				}
				me._slobesedilo1.ggParameter.sx=1;me._slobesedilo1.ggParameter.sy=1;
				me._slobesedilo1.style[domTransform]=parameterToTransform(me._slobesedilo1.ggParameter);
				me._slotekst1.style[domTransition]='none';
				me._slotekst1.style.visibility='inherit';
				me._slotekst1.ggVisible=true;
			}
			this._slobesedilo1.onmouseout=function () {
				me._slobesedilo1.style[domTransition]='none';
				me._slobesedilo1.style.opacity='0.8';
				me._slobesedilo1.style.visibility=me._slobesedilo1.ggVisible?'inherit':'hidden';
				if (me.player.transitionsDisabled) {
					me._slobesedilo1.style[domTransition]='none';
				} else {
					me._slobesedilo1.style[domTransition]='all 500ms ease-out 0ms';
				}
				me._slobesedilo1.ggParameter.sx=0.5;me._slobesedilo1.ggParameter.sy=0.5;
				me._slobesedilo1.style[domTransform]=parameterToTransform(me._slobesedilo1.ggParameter);
			}
			this.__div.appendChild(this._slobesedilo1);
		} else
		if (hotspot.skinid=='naprej_levo') {
			this.__div=document.createElement('div');
			this.__div.ggId='naprej_levo'
			this.__div.ggParameter={ rx:0,ry:0,a:0,sx:1,sy:1 };
			this.__div.ggVisible=true;
			hs ='position:absolute;';
			hs+='left: 230px;';
			hs+='top:  180px;';
			hs+='width: 5px;';
			hs+='height: 5px;';
			hs+=cssPrefix + 'transform-origin: 0% 0%;';
			hs+='visibility: inherit;';
			this.__div.setAttribute('style',hs);
			this.__div.onclick=function () {
				me.player.openUrl(me.hotspot.url,"&ht");
				me.skin.hotspotProxyClick(me.hotspot.id);
			}
			this.__div.onmouseover=function () {
				me.player.hotspot=me.hotspot;
				me.player.openUrl(me.hotspot.url,"&ht");
				me.skin.hotspotProxyOver(me.hotspot.id);
			}
			this.__div.onmouseout=function () {
				me.player.hotspot=me.player.emptyHotspot;
				me.skin.hotspotProxyOut(me.hotspot.id);
			}
			this._slotekst0=document.createElement('div');
			this._slotekst0.ggId='SLOTekst'
			this._slotekst0.ggParameter={ rx:0,ry:0,a:0,sx:1,sy:1 };
			this._slotekst0.ggVisible=false;
			hs ='position:absolute;';
			hs+='left: -115px;';
			hs+='top:  -55px;';
			hs+='width: 225px;';
			hs+='height: auto;';
			hs+=cssPrefix + 'transform-origin: 0% 0%;';
			hs+='opacity: 0;';
			hs+='visibility: hidden;';
			hs+='border: 1px solid #ff0000;';
			hs+='color: #ffffff;';
			hs+='background-color: #3b3b3b;';
			hs+='text-align: left;';
			hs+='white-space: pre-wrap;';
			hs+='padding: 0px 1px 0px 1px;'
			hs+='overflow: hidden;';
			this._slotekst0.setAttribute('style',hs);
			this._slotekst0.innerHTML=me.hotspot.title;
			this._slotekst0.onclick=function () {
				me._slotekst0.style[domTransition]='none';
				me._slotekst0.style.opacity='0';
				me._slotekst0.style.visibility='hidden';
			}
			this.__div.appendChild(this._slotekst0);
			this._slobesedilo0=document.createElement('div');
			this._slobesedilo0.ggId='slobesedilo'
			this._slobesedilo0.ggParameter={ rx:0,ry:0,a:0,sx:0.5,sy:0.5 };
			this._slobesedilo0.ggVisible=true;
			hs ='position:absolute;';
			hs+='left: -20px;';
			hs+='top:  -20px;';
			hs+='width: 100px;';
			hs+='height: 100px;';
			hs+=cssPrefix + 'transform-origin: 50% 50%;';
			hs+=cssPrefix + 'transform: ' + parameterToTransform(this._slobesedilo0.ggParameter) + ';';
			hs+='opacity: 0.8;';
			hs+='visibility: inherit;';
			hs+='cursor: pointer;';
			this._slobesedilo0.setAttribute('style',hs);
			this._slobesedilo0__img=document.createElement('img');
			this._slobesedilo0__img.setAttribute('src',basePath + 'images/slobesedilo0.png');
			this._slobesedilo0__img.setAttribute('style','position: absolute;top: 0px;left: 0px;');
			me.player.checkLoaded.push(this._slobesedilo0__img);
			this._slobesedilo0.appendChild(this._slobesedilo0__img);
			this._slobesedilo0.onmouseover=function () {
				me._slobesedilo0.style[domTransition]='none';
				me._slobesedilo0.style.opacity='1';
				me._slobesedilo0.style.visibility=me._slobesedilo0.ggVisible?'inherit':'hidden';
				if (me.player.transitionsDisabled) {
					me._slobesedilo0.style[domTransition]='none';
				} else {
					me._slobesedilo0.style[domTransition]='all 500ms ease-out 0ms';
				}
				me._slobesedilo0.ggParameter.sx=1;me._slobesedilo0.ggParameter.sy=1;
				me._slobesedilo0.style[domTransform]=parameterToTransform(me._slobesedilo0.ggParameter);
				me._slotekst0.style[domTransition]='none';
				me._slotekst0.style.visibility='inherit';
				me._slotekst0.ggVisible=true;
			}
			this._slobesedilo0.onmouseout=function () {
				me._slobesedilo0.style[domTransition]='none';
				me._slobesedilo0.style.opacity='0.8';
				me._slobesedilo0.style.visibility=me._slobesedilo0.ggVisible?'inherit':'hidden';
				if (me.player.transitionsDisabled) {
					me._slobesedilo0.style[domTransition]='none';
				} else {
					me._slobesedilo0.style[domTransition]='all 500ms ease-out 0ms';
				}
				me._slobesedilo0.ggParameter.sx=0.5;me._slobesedilo0.ggParameter.sy=0.5;
				me._slobesedilo0.style[domTransform]=parameterToTransform(me._slobesedilo0.ggParameter);
			}
			this.__div.appendChild(this._slobesedilo0);
		} else
		if (hotspot.skinid=='naprej_desno') {
			this.__div=document.createElement('div');
			this.__div.ggId='naprej_desno'
			this.__div.ggParameter={ rx:0,ry:0,a:0,sx:1,sy:1 };
			this.__div.ggVisible=true;
			hs ='position:absolute;';
			hs+='left: 230px;';
			hs+='top:  180px;';
			hs+='width: 5px;';
			hs+='height: 5px;';
			hs+=cssPrefix + 'transform-origin: 0% 0%;';
			hs+='visibility: inherit;';
			this.__div.setAttribute('style',hs);
			this.__div.onclick=function () {
				me.player.openUrl(me.hotspot.url,"&ht");
				me.skin.hotspotProxyClick(me.hotspot.id);
			}
			this.__div.onmouseover=function () {
				me.player.hotspot=me.hotspot;
				me.player.openUrl(me.hotspot.url,"&ht");
				me.skin.hotspotProxyOver(me.hotspot.id);
			}
			this.__div.onmouseout=function () {
				me.player.hotspot=me.player.emptyHotspot;
				me.skin.hotspotProxyOut(me.hotspot.id);
			}
			this._slotekst=document.createElement('div');
			this._slotekst.ggId='SLOTekst'
			this._slotekst.ggParameter={ rx:0,ry:0,a:0,sx:1,sy:1 };
			this._slotekst.ggVisible=false;
			hs ='position:absolute;';
			hs+='left: -115px;';
			hs+='top:  -55px;';
			hs+='width: 225px;';
			hs+='height: auto;';
			hs+=cssPrefix + 'transform-origin: 0% 0%;';
			hs+='opacity: 0;';
			hs+='visibility: hidden;';
			hs+='border: 1px solid #ff0000;';
			hs+='color: #ffffff;';
			hs+='background-color: #3b3b3b;';
			hs+='text-align: left;';
			hs+='white-space: pre-wrap;';
			hs+='padding: 0px 1px 0px 1px;'
			hs+='overflow: hidden;';
			this._slotekst.setAttribute('style',hs);
			this._slotekst.innerHTML=me.hotspot.title;
			this._slotekst.onclick=function () {
				me._slotekst.style[domTransition]='none';
				me._slotekst.style.opacity='0';
				me._slotekst.style.visibility='hidden';
			}
			this.__div.appendChild(this._slotekst);
			this._slobesedilo=document.createElement('div');
			this._slobesedilo.ggId='slobesedilo'
			this._slobesedilo.ggParameter={ rx:0,ry:0,a:0,sx:0.5,sy:0.5 };
			this._slobesedilo.ggVisible=true;
			hs ='position:absolute;';
			hs+='left: -20px;';
			hs+='top:  -20px;';
			hs+='width: 100px;';
			hs+='height: 100px;';
			hs+=cssPrefix + 'transform-origin: 50% 50%;';
			hs+=cssPrefix + 'transform: ' + parameterToTransform(this._slobesedilo.ggParameter) + ';';
			hs+='opacity: 0.8;';
			hs+='visibility: inherit;';
			hs+='cursor: pointer;';
			this._slobesedilo.setAttribute('style',hs);
			this._slobesedilo__img=document.createElement('img');
			this._slobesedilo__img.setAttribute('src',basePath + 'images/slobesedilo.png');
			this._slobesedilo__img.setAttribute('style','position: absolute;top: 0px;left: 0px;');
			me.player.checkLoaded.push(this._slobesedilo__img);
			this._slobesedilo.appendChild(this._slobesedilo__img);
			this._slobesedilo.onmouseover=function () {
				me._slobesedilo.style[domTransition]='none';
				me._slobesedilo.style.opacity='1';
				me._slobesedilo.style.visibility=me._slobesedilo.ggVisible?'inherit':'hidden';
				if (me.player.transitionsDisabled) {
					me._slobesedilo.style[domTransition]='none';
				} else {
					me._slobesedilo.style[domTransition]='all 500ms ease-out 0ms';
				}
				me._slobesedilo.ggParameter.sx=1;me._slobesedilo.ggParameter.sy=1;
				me._slobesedilo.style[domTransform]=parameterToTransform(me._slobesedilo.ggParameter);
				me._slotekst.style[domTransition]='none';
				me._slotekst.style.visibility='inherit';
				me._slotekst.ggVisible=true;
			}
			this._slobesedilo.onmouseout=function () {
				me._slobesedilo.style[domTransition]='none';
				me._slobesedilo.style.opacity='0.8';
				me._slobesedilo.style.visibility=me._slobesedilo.ggVisible?'inherit':'hidden';
				if (me.player.transitionsDisabled) {
					me._slobesedilo.style[domTransition]='none';
				} else {
					me._slobesedilo.style[domTransition]='all 500ms ease-out 0ms';
				}
				me._slobesedilo.ggParameter.sx=0.5;me._slobesedilo.ggParameter.sy=0.5;
				me._slobesedilo.style[domTransform]=parameterToTransform(me._slobesedilo.ggParameter);
			}
			this.__div.appendChild(this._slobesedilo);
		} else
		{
			this.__div=document.createElement('div');
			this.__div.ggId='info'
			this.__div.ggParameter={ rx:0,ry:0,a:0,sx:1,sy:1 };
			this.__div.ggVisible=true;
			this.__div.ggUpdatePosition=function() {
				this.style[domTransition]='none';
				if (this.parentNode) {
					w=this.parentNode.offsetWidth;
					this.style.left=(5 + w/2) + 'px';
					h=this.parentNode.offsetHeight;
					this.style.top=(-18 + h/2) + 'px';
				}
			}
			hs ='position:absolute;';
			hs+='left: 5px;';
			hs+='top:  -18px;';
			hs+='width: 5px;';
			hs+='height: 5px;';
			hs+=cssPrefix + 'transform-origin: 50% 50%;';
			hs+='visibility: inherit;';
			hs+='cursor: pointer;';
			this.__div.setAttribute('style',hs);
			this.__div.onclick=function () {
				me.skin.hotspotProxyClick(me.hotspot.id);
			}
			this.__div.onmouseover=function () {
				me.player.hotspot=me.hotspot;
				me.skin.hotspotProxyOver(me.hotspot.id);
			}
			this.__div.onmouseout=function () {
				me.player.hotspot=me.player.emptyHotspot;
				me.skin.hotspotProxyOut(me.hotspot.id);
			}
			this._imagehs=document.createElement('div');
			this._imagehs.ggId='image-hs'
			this._imagehs.ggParameter={ rx:0,ry:0,a:0,sx:0.9,sy:0.9 };
			this._imagehs.ggVisible=true;
			hs ='position:absolute;';
			hs+='left: -25px;';
			hs+='top:  -25px;';
			hs+='width: 50px;';
			hs+='height: 50px;';
			hs+=cssPrefix + 'transform-origin: 50% 50%;';
			hs+=cssPrefix + 'transform: ' + parameterToTransform(this._imagehs.ggParameter) + ';';
			hs+='visibility: inherit;';
			hs+='cursor: pointer;';
			this._imagehs.setAttribute('style',hs);
			this._imagehs__img=document.createElement('img');
			this._imagehs__img.setAttribute('src',basePath + 'images/imagehs.png');
			this._imagehs__img.setAttribute('style','position: absolute;top: 0px;left: 0px;');
			me.player.checkLoaded.push(this._imagehs__img);
			this._imagehs.appendChild(this._imagehs__img);
			this._imagehs.onclick=function () {
				flag=(me._image.style.visibility=='hidden');
				me._image.style[domTransition]='none';
				me._image.style.visibility=flag?'inherit':'hidden';
				me._image.ggVisible=flag;
			}
			this._imagehs.onmouseover=function () {
				if (me.player.transitionsDisabled) {
					me._imagehs.style[domTransition]='none';
				} else {
					me._imagehs.style[domTransition]='all 500ms ease-out 0ms';
				}
				me._imagehs.style.opacity='1';
				me._imagehs.style.visibility=me._imagehs.ggVisible?'inherit':'hidden';
				if (me.player.transitionsDisabled) {
					me._imagehs.style[domTransition]='none';
				} else {
					me._imagehs.style[domTransition]='all 500ms ease-out 0ms';
				}
				me._imagehs.ggParameter.sx=1;me._imagehs.ggParameter.sy=1;
				me._imagehs.style[domTransform]=parameterToTransform(me._imagehs.ggParameter);
			}
			this._imagehs.onmouseout=function () {
				if (me.player.transitionsDisabled) {
					me._imagehs.style[domTransition]='none';
				} else {
					me._imagehs.style[domTransition]='all 500ms ease-out 0ms';
				}
				me._imagehs.style.opacity='1';
				me._imagehs.style.visibility=me._imagehs.ggVisible?'inherit':'hidden';
				if (me.player.transitionsDisabled) {
					me._imagehs.style[domTransition]='none';
				} else {
					me._imagehs.style[domTransition]='all 500ms ease-out 0ms';
				}
				me._imagehs.ggParameter.sx=1;me._imagehs.ggParameter.sy=1;
				me._imagehs.style[domTransform]=parameterToTransform(me._imagehs.ggParameter);
			}
			this.__div.appendChild(this._imagehs);
			this._image=document.createElement('div');
			this._image.ggId='image'
			this._image.ggParameter={ rx:0,ry:0,a:0,sx:1,sy:1 };
			this._image.ggVisible=true;
			hs ='position:absolute;';
			hs+='left: -240px;';
			hs+='top:  -150px;';
			hs+='width: 467px;';
			hs+='height: auto;';
			hs+=cssPrefix + 'transform-origin: 50% 50%;';
			hs+='visibility: inherit;';
			hs+='cursor: pointer;';
			hs+='border: 1px solid #aa0000;';
			hs+='color: #ffffff;';
			hs+='background-color: #000000;';
			hs+='text-align: center;';
			hs+='white-space: pre-wrap;';
			hs+='padding: 0px 1px 0px 1px;'
			hs+='overflow: hidden;';
			this._image.setAttribute('style',hs);
			this._image.innerHTML=me.hotspot.title;
			this._image.onclick=function () {
				flag=(me._image.style.visibility=='hidden');
				me._image.style[domTransition]='none';
				me._image.style.visibility=flag?'inherit':'hidden';
				me._image.ggVisible=flag;
			}
			this.__div.appendChild(this._image);
		}
	};
	this.addSkinHotspot=function(hotspot) {
		return new SkinHotspotClass(me,hotspot);
	}
	this.addSkin();
};